import API from 'services/API/index';

export default function closeBanner(id) {
  return API.request({
    method: 'DELETE',
    url: `/banner/system/${id}`,
  });
}
